import { BaseModel } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
export class ReferenceConfigDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  companyId!: number;
}
